import "./Home.module.css";
import Nagłówek from "@/reusable_sections/Header";
import FundamentTwojejHodowli from "./sections/FundamentTwojejHodowli";
import ZaletyBlachyT18 from "./sections/ZaletyBlachyT18";
import MenuWybranychUslug from "./sections/MenuWybranychUslug";
import BehindTheCode from "./sections/BehindTheCode";
import ProstaDrogaDoPysznegoObiadu from "./sections/ProstaDrogaDoPysznegoObiadu";
import LetsTalkAboutProject from "./sections/LetsTalkAboutProject";
import TrainerFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Nagłówek />
      <FundamentTwojejHodowli />
      <ZaletyBlachyT18 />
      <MenuWybranychUslug />
      <BehindTheCode />
      <ProstaDrogaDoPysznegoObiadu />
      <LetsTalkAboutProject />
      <TrainerFooter />
    </div>;
}